"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExtentFromGeometry = getExtentFromGeometry;

var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON"));

var format = new _GeoJSON["default"]();

function getExtentFromGeometry(geometry) {
  return format.readGeometry(geometry).getExtent();
}